import { useEffect, useState } from "react";
import axios from "axios";

export const useParenProducts = (parentCategoryName: string, lang: string) => {
  const [data, setData] = useState<null | any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const apiUrl = process.env.REACT_APP_API_URL; // URL from your environment variables

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        // Make sure axios uses the full URL
        const response = await axios.get(
          `${apiUrl}/api/parent/${parentCategoryName}`
        );
        setData(response.data);
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [parentCategoryName, lang, apiUrl]); // Ensure apiUrl is included as a dependency

  return { data, loading, error };
};
